import { useAtomValue } from 'jotai';
import { ModuleKeyType } from 'lib/api/company/types';
import React, { createContext, ReactNode, useMemo, useContext } from 'react';
import { companyIdAtom, enabledModulesAtom } from 'views/state';

type ModuleAccessContextType = {
  enabledModules: ModuleKeyType[];
  isLoading: boolean;
  hasModule: (module: ModuleKeyType) => boolean;
};

const ModuleAccessContext = createContext<ModuleAccessContextType>({
  enabledModules: [],
  isLoading: true,
  hasModule: () => false,
});

export const ModuleAccessProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const companyId = useAtomValue(companyIdAtom);
  const enabledModules = useAtomValue(enabledModulesAtom);
  const isLoading = !companyId; // Loading if no company is selected

  const contextValue = useMemo(
    () => ({
      enabledModules,
      isLoading,
      hasModule: (module: ModuleKeyType) => enabledModules.includes(module),
    }),
    [enabledModules, isLoading, companyId],
  );

  return (
    <ModuleAccessContext.Provider value={contextValue}>
      {children}
    </ModuleAccessContext.Provider>
  );
};

export const useModuleAccess = () => useContext(ModuleAccessContext);
